const apiBaseUrl =
  process.env.NODE_ENV === "production"
    ? `https://${process.env.REACT_APP_PROD_HOSTNAME}:3001`
    : "http://localhost:3001";

const getThreadByIdPath = "/getThreadById";
const getThreadIdFromTweetPath = "/getThreadIdFromTweet";
const getRecentThreadsPath = "/getRecentThreads";

async function post(path, data) {
  return await fetch(`${apiBaseUrl}${path}`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  }).then((res) => res.json());
}

export async function getThreadById(threadId) {
  return await post(getThreadByIdPath, { threadId });
}

export async function getThreadIdFromTweet(
  tweetId,
  invalidateCache,
  existingThreadId
) {
  return await post(getThreadIdFromTweetPath, {
    tweetId,
    invalidateCache,
    existingThreadId,
  });
}

export async function getRecentThreads(since) {
  return await post(getRecentThreadsPath, { since });
}
